import { Nullable } from '@internal-libraries/kheops-ui-lib'
import Room from './ClvrRoom'

export default class OperatingRoom {
    public constructor(
        public id: number,
        public groupId: number,
        public name: string,
        public type: string,
        public daysLocked: Nullable<number>,
        public phone: Nullable<string>,
        public fax: Nullable<string>,
        public useStretcher: Nullable<boolean>,
        public ambuPreopTime: Nullable<string>,
        public checklistEveryday: Nullable<boolean>,
        public active: Nullable<boolean>,
        public rooms: Room[],
    ) {}
}
